import { render, staticRenderFns } from "./DmqCheckoutAddressRadios.vue?vue&type=template&id=0832c94a&"
import script from "./DmqCheckoutAddressRadios.vue?vue&type=script&lang=ts&"
export * from "./DmqCheckoutAddressRadios.vue?vue&type=script&lang=ts&"
import style0 from "./DmqCheckoutAddressRadios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports